import * as ActionType from '../ActionTypes';

export const SetColumnSortSettings = (setting: {}) => {
  return {
    type: ActionType.SET_COLUMN_SORT_SETTINGS,
    payload: setting
  };
}

export const SetColumnFilterSettings = (setting: {}) => {
  return {
    type: ActionType.SET_COLUMN_FILTER_SETTINGS,
    payload: setting
  };
}